import { AlertButton, AlertOptions, useIonAlert } from "@ionic/react";
import style from "./Navigation.module.scss";
type MessageProps = {
    title: string,
    message: string;
};

export type AlertProps = MessageProps & {
    buttonTitle: string;
    cssClass?: AlertOptions["cssClass"];
    buttonId?: AlertButton["id"];
};

export type DialogProps = MessageProps & {
    confirmButtonTitle: string,
    cancelButtonTitle: string;
};

export type DoubleConfirmDialogProps = DialogProps & {
    areYouSureButtonTitle: string;
};

const useAlert = () =>
{
    const [present] = useIonAlert();
    return ({ title, message, buttonTitle = 'OK', cssClass, buttonId }: AlertProps) =>
    {
        return new Promise((resolve) =>
        {
            present({
                header: title,
                message,
                buttons: [{
                    text: buttonTitle,
                    id: buttonId,
                    role: 'confirm',
                    cssClass: cssClass,
                    handler: () => resolve(true),
                }]
            });
        });
    };
};

const useDialog = () =>
{
    const [present] = useIonAlert();
    return ({ title, message, confirmButtonTitle = 'OK', cancelButtonTitle = 'Cancel' }: DialogProps) =>
    {
        return new Promise((resolve) =>
        {
            present({
                header: title,
                message,
                buttons: [{
                    text: confirmButtonTitle,
                    role: 'confirm',
                    handler: () => resolve(true)
                },
                {
                    text: cancelButtonTitle,
                    role: 'cancel',
                    handler: () => resolve(false)
                }]
            });
        });
    };
};

const useDoubleConfirmDialog = () =>
{
    const [present] = useIonAlert();

    return ({ title, message, areYouSureButtonTitle = 'Are you sure', confirmButtonTitle = 'OK', cancelButtonTitle = 'Cancel' }: DoubleConfirmDialogProps) =>
    {

        const id1 = `${title}-1`;
        const id2 = `${title}-2`;

        return new Promise((resolve) =>
        {
            present({
                header: title,
                message,
                buttons: [{
                    id: id1,
                    text: confirmButtonTitle,
                    handler: () =>
                    {
                        const s = document.getElementById(id1);
                        const o = document.getElementById(id2);

                        o?.classList.remove('confirm-hidden');
                        s?.classList.add('confirm-hidden');

                        return false;
                    }
                }, {
                    id: id2,
                    text: `${areYouSureButtonTitle} - ${confirmButtonTitle}`,
                    cssClass: "confirm-hidden",
                    role: 'confirm',
                    handler: () => { resolve(true); }
                },
                {
                    text: cancelButtonTitle,
                    role: 'cancel',
                    handler: () => resolve(false)
                }]
            });
        });
    };
};

export { useAlert, useDialog, useDoubleConfirmDialog };
